import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 8" {...props}><path xmlns="http://www.w3.org/2000/svg" stroke="#A0A0AA" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 1 7 7 1 1" /></svg>;
export default Component;